import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchWorkerUptime(
  workerId: string,
  period: Period
): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    enabled: !!workerId,
    queryKey: ['useFetchWorkerUptime', workerId, period],
    queryFn: () => api.get(`/worker/stats/uptime?id=${workerId}&period=${period}`),
    staleTime: 0,
    retry: 0
  })
}
